import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { InputComponent } from './input/input.component';
import { LabelComponent } from './label/label.component';
import { OpenEmailComponent } from './open-email/open-email.component';
import { ResponseErrorMessages } from './response-error-messages/response-error-messages.component';
import { SpinnerLoadComponent } from './spinner-load/spinner-load.component';
import { SystemLanguagesSelectorComponent } from './system-languages-selector/system-languages-selector.component';
import { TvlDropdownComponent } from './tvl-dropdown/tvl-dropdown.component';

const STANDARD_COMPONENTS = [TvlDropdownComponent];

@NgModule({
  imports: [
    TranslateModule.forChild(),
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BsDropdownModule.forRoot(),
    ...STANDARD_COMPONENTS,
  ],
  declarations: [
    LabelComponent,
    InputComponent,
    ResponseErrorMessages,
    OpenEmailComponent,
    SpinnerLoadComponent,
    SystemLanguagesSelectorComponent,
  ],
  exports: [
    LabelComponent,
    InputComponent,
    ResponseErrorMessages,
    OpenEmailComponent,
    SpinnerLoadComponent,

    SystemLanguagesSelectorComponent,
  ],
})
export class CommonComponentsModule {}
